import { memo } from 'react';

import { AssetModalLeftPanelContent } from '~/components/AssetModalV2/Content/Panel/components/AssetModalLeftPanelContent';
import { PublicVersionsList } from '~/components/v2/components/asset-modal/desktop/versions/PublicVersionsList';
import { PublicVersionsPanelHeader } from '~/components/v2/components/asset-modal/desktop/versions/PublicVersionsPanelHeader';

export const PublicVersionsPanel = memo(() => {
  return (
    <AssetModalLeftPanelContent>
      <div className="flex h-full min-h-0 flex-col" data-testid="PUBLIC_VERSIONS_PANEL">
        <PublicVersionsPanelHeader />
        <div
          className="scrollbar scrollbar-track-gray-2 scrollbar-thumb-gray-7 [&:not(:hover)]:scrollbar-track-transparent min-h-0 flex-1 overflow-y-auto px-2 py-4"
          data-testid="PUBLIC_VERSIONS_PANEL_CONTENT"
        >
          <PublicVersionsList />
        </div>
      </div>
    </AssetModalLeftPanelContent>
  );
});

PublicVersionsPanel.displayName = 'PublicVersionsPanel';
